import { useState } from 'react';

import utils from '../libs/utils';

const useLoadingStatus = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const executeWithStatus = async (execute: () => Promise<void>, onError?: (err: Error) => {}) => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      await execute();
    } catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
      if (onError) onError(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    setIsLoading,
    errorMessage,
    setErrorMessage,
    executeWithStatus
  };
};

export default useLoadingStatus;
